var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8901 12.7797C12.8201 12.7697 12.7301 12.7697 12.6501 12.7797C10.8901 12.7197 9.49011 11.2797 9.49011 9.50974C9.49011 7.69974 10.9501 6.22974 12.7701 6.22974C14.5801 6.22974 16.0501 7.69974 16.0501 9.50974C16.0401 11.2797 14.6501 12.7197 12.8901 12.7797Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5102 19.3798C17.7302 21.0098 15.3702 21.9998 12.7702 21.9998C10.1702 21.9998 7.81015 21.0098 6.03015 19.3798C6.13015 18.4398 6.73015 17.5198 7.80015 16.7998C10.5402 14.9798 15.0202 14.9798 17.7402 16.7998C18.8102 17.5198 19.4102 18.4398 19.5102 19.3798Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7701 21.9998C18.293 21.9998 22.7701 17.5226 22.7701 11.9998C22.7701 6.47691 18.293 1.99976 12.7701 1.99976C7.24729 1.99976 2.77014 6.47691 2.77014 11.9998C2.77014 17.5226 7.24729 21.9998 12.7701 21.9998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3a0887b969cc8e172e14a426132f68a5.svg";
export { ForwardRef as ReactComponent };